/**
 * Liczba po polsku — przecinek dziesiętny, jedno miejsce po przecinku:
 * 27,7 · 1162,1. „27.7 h” na ekranie po polsku wygląda na błąd.
 */
export function plNumber(n: number, digits = 1): string {
  return n.toLocaleString('pl-PL', {
    maximumFractionDigits: digits,
    minimumFractionDigits: 0,
  });
}

/**
 * Rozmiar pliku po polsku: „1,5 MB” albo „240 KB” — przecinek dziesiętny,
 * jak w każdej innej liczbie na ekranie (`plNumber`). Pusty napis, gdy
 * rozmiaru nie znamy — brak danych to nie „0 KB”.
 */
export function fileSizeText(bytes?: number | null): string {
  if (bytes == null || !Number.isFinite(bytes)) return '';
  return bytes > 1_000_000
    ? `${plNumber(bytes / 1_000_000)} MB`
    : `${Math.round(bytes / 1024)} KB`;
}
